import { render, staticRenderFns } from "./SubmitCampaign.vue?vue&type=template&id=6c63ca2c"
import script from "./SubmitCampaign.vue?vue&type=script&lang=js"
export * from "./SubmitCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports